import { enableMapSet } from "immer";

export function mainSideEffects() {
  enableMapSet();
}
